export default __webpack_public_path__ + "static/media/screen8.ae1500c2.png";